import { Autocomplete, Box, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

const UsersListAutocomplete = ({ loggedInUser, selectedUser, setSelectedUser }) => {

    const [users, setUsers] = useState()

    useEffect(() => {
        const endpoint = '/algo-trading/api/admin/users';
        fetch(endpoint, {
            headers: new Headers({
                'Authorization': loggedInUser.credential
            }),
        }
        ).then(r => {
            if (r.status >= 400) {
                return
            }
            r.text()
                .then(value => {
                    setUsers(JSON.parse(value))
                })
        }
        ).catch(error => {
            console.log(error);
            // history.push('/')
        });
    }, [loggedInUser]);

    return (
        <>
            {users && users.length > 0 && (
                <Grid item xs={12}>
                    <Box sx={{ minWidth: 120, maxWidth: 300 }}>
                        <Autocomplete
                            options={users}
                            getOptionLabel={user => user?.name}
                            isOptionEqualToValue={(option, value) => option.token === value.token}
                            renderInput={(params) => (
                                <TextField {...params}
                                    size={"small"}
                                    label="User"
                                    variant="outlined"
                                    value={selectedUser}
                                    fullWidth={true}
                                    placeholder={"Enter user name"}
                                />
                            )}
                            onChange={(event, value) => setSelectedUser(value)}
                            key={"2"}
                        >
                        </Autocomplete>
                    </Box>
                </Grid >
            )}
        </>
    )
}

export default UsersListAutocomplete